export default __webpack_public_path__ + "static/media/suppliers.d379e3e5.svg";